import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import vueSelect from 'vue-select'
Vue.component(FeatherIcon.name, FeatherIcon, vueSelect)